import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import { GetMedicationsReq, GetMedicationsRes } from './medications.types';

export const medicationsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getMedications: build.query<GetMedicationsRes, GetMedicationsReq>({
      query: (params) => ({
        params,
        url: '/medications'
      })
    })
  }),
  reducerPath: 'medicationsApi',
  tagTypes: ['medications']
});

export const { useGetMedicationsQuery, useLazyGetMedicationsQuery } = medicationsApi;
